import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'

const MarkJuniorTalentMenuItem = ({supplier = null, refetch, disabled}) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    fetch(`/rest/v2/supplier/${supplier.uid}/set-junior-type`, {
      credentials: 'same-origin',
      method: 'PUT'
    })
    .then((response) => response.json())
    .then((response) => {
        toastr.success(formatMessage(messages.success))
        refetch()
    })
    .catch((error) => {
        toastr.error(error)
    })
  }

  return (
    <Menu.Item disabled={disabled}>
      <MenuButton disabled={disabled} onClick={onClick}>
        { formatMessage(messages.markJuniorTalent) }
      </MenuButton>
    </Menu.Item>
  )
}

export default MarkJuniorTalentMenuItem
